<template>
  <div class="container">
    <!--登录页面-->
    <div class="dengl">
      <div class="dly">
        <div class="dlyt fl"><img src="@/view/images/y75.jpg" /></div>
        <div class="dlyw fr">
          <div class="dlywa">
            <h6>欢迎登录印工社</h6>
            <p><a href="javascript:vold(0);" @click="login">账号密码登陆</a></p>
          </div>
          <div class="dlywb">
            <div class="dlywb_a">
              <p>账号</p>
              <input
                class="input1"
                v-model.number="mobile"
                type="text"
                value="请输入您的手机号"
                onfocus="if(value=='请输入您的手机号') {value=''}"
                onblur="if (value=='') {value='请输入您的手机号'}"
              />
            </div>
            <div class="dlywb_a">
              <p>验证码</p>
              <div class="zhaoha_a">
                <input
                  class="input1"
                  v-model.trim="codenum"
                  type="text"
                  value="请输入手机验证码"
                  onfocus="if(value=='请输入手机验证码') {value=''}"
                  onblur="if (value=='') {value='请输入手机验证码'}"
                />
                <span
                  ><a href="javascript:void(0);" @click="codesub"
                    >获取验证码</a
                  ></span
                >
              </div>
            </div>
            <div class="dlywb_b">
              <input type="submit" value="登录" />
            </div>
          </div>
          <div class="dlywc">
            <p class="fl">
              <a href="javascript:void(0);" @click="register">注册帐号</a>
            </p>
            <p class="fr">
              <a href="javascript:void(0);" @click="forget">忘记密码</a>
            </p>
            <div class="clearfix"></div>
          </div>
          <div class="dlywd">
            <p>
              登录即表示已同意本平台<a href="#">《印工用户社服务协议》</a>和<a
                href="javascript:void(0);"
                @click="privacy"
                >《隐私政策声明》</a
              >
            </p>
          </div>
        </div>
      </div>
      <div class="yjd">
        <p>
          Copyright© 2019-2021 印工社（青岛）数字科技有限公司 All Rights
          Reserved<span>|</span
          ><a
            href="https://beian.miit.gov.cn"
            target="_banck"
            style="corsor:pointer"
          >
            鲁ICP备20000134号-3</a
          ><span></span><a href="https://beian.mps.gov.cn/#/query/webSearch?code=37021402002207\" target="_banck">鲁公网安备 37021402002207号</a><span class="span1">|</span
          >网站建设：<a href="#">一瞬网络</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'codePhone',
  data() {
    return {
      mobile: '请输入您的手机号',
      codenum: '请输入验证码',
    };
  },
  methods: {
    init() {},
    login() {
      this.$router.push({ path: '/login' });
    },
    register() {
      this.$router.push({ path: '/register' });
    },
    forget() {
      this.$router.push({ path: '/forget' });
    },
    privacy() {
      this.$router.push({ path: '/privacy' });
    },
    codesub() {
      const _this = this;
      const { mobile } = _this;
      const prams = {
        phone: mobile,
      };
      const url = `${process.env.API_HOST}/psl/user/code/regist`; // HOME变量为已挂载的可跨域域名，这里将其拼接完，成为一个完整路径
      this.$axios({
        // this代表vue对象，之前在入口文件中把axios挂载到了vue中，所以这里直接用this.$axios调用axios对象
        method: 'post',
        url,
        data: prams,
      }).then((res) => {
        console.log(res, 'codesub');
        const json = res.data;
        if (json.code === 200) {
          if (json.message.success) {
            _this.$notify({
              title: '提示',
              message: json.message.message,
              type: 'success',
            });
          } else {
            _this.$notify.error({
              title: '提示',
              message: json.message.message,
            });
          }
        }
      });
    },
  },
  mounted() {},
  created() {
    this.init();
  },
};
</script>

<style scoped>
.container {
  background-color: #273142;
  width: 100%;
  height: 100vh;
}
.dengl .yjd {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/view/codepohone.vue